import React, {createContext} from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import reportWebVitals from './reportWebVitals'

import Store from './core/store'
import AdminStore from './core/store/admin'
import ShopStore from './core/store/shop'
import PagesStore from './core/store/pages'
import StudioStore from './core/store/studio'

interface State {
  store: Store
  adminStore: AdminStore
  shopStore: ShopStore
  pagesStore: PagesStore
  studioStore: StudioStore
}

const store = new Store()
const adminStore = new AdminStore()
const shopStore = new ShopStore()
const pagesStore = new PagesStore()
const studioStore = new StudioStore()

export const Context = createContext<State>({store, adminStore, shopStore, pagesStore, studioStore})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <React.StrictMode>
    <Context.Provider value={{store, adminStore, shopStore, pagesStore, studioStore}}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Context.Provider>
  </React.StrictMode>
)

reportWebVitals()
